<div class="panel clearfix">
  <div class="row">
    <div class="columns small-12 medium-8">
      <p class="rs-font-pxB ts-txt-s3">
        {{ 'alarmThresholds.description' | translate }}
      </p>
      <form
        *ngIf="updateThresholdsForm"
        (ngSubmit)="updateThresholds()"
        [formGroup]="updateThresholdsForm"
      >
        <div
          class="rs-form-item"
          [ngClass]="{
            error: updateThresholdsForm?.get('notification1').status !== 'VALID',
            'rs-form-success':
              !updateThresholdsForm?.getError('mustBeDifferent') &&
              !updateThresholdsForm?.getError('atLeastOne') &&
              updateThresholdsForm?.get('notification1').status === 'VALID'
          }"
        >
          <div class="rs-flex-row rs-flex-middle">
            <div class="rs-flex-columns small-11 medium-6">
              <input
                *ngIf="isRes"
                type="number"
                id="notification1"
                formControlName="notification1"
                aria-describedby="ac-helper1"
                data-cy="alarmThresholdNotification1"
              />
              <input
                *ngIf="!isRes"
                type="number"
                step="0.01"
                id="notification1"
                formControlName="notification1"
                aria-describedby="ac-helper1"
              />
              <label
                class="rs-form-label"
                for="notification1"
                aria-describedby="ac-error1"
                [ngClass]="{
                  error:
                    updateThresholdsForm?.getError('mustBeDifferent') ||
                    updateThresholdsForm?.getError('atLeastOne') ||
                    updateThresholdsForm?.get('notification1').status !== 'VALID'
                }"
                >{{ 'alarmThresholds.firstNotificationLabel' | translate }}</label
              >
            </div>
            <div *ngIf="isRes" class="rs-flex-columns small-1 medium-6">€</div>
            <div *ngIf="!isRes" class="rs-flex-columns small-1 medium-6">
              € {{ 'alarmThresholds.vat.excluded' | translate }}
            </div>
            <span
              id="ac-error1"
              class="error"
              *ngIf="
                updateThresholdsForm?.get('notification1')?.getError('min') ||
                updateThresholdsForm?.get('notification1')?.getError('max')
              "
              >{{ 'alarmThresholds.invalidIntervalAlarmThreshold' | translate }}</span
            >
            <span
              id="ac-error1"
              class="rs-form-helper"
              *ngIf="updateThresholdsForm?.getError('atLeastOne')"
              >{{ 'alarmThresholds.invalidIntervalAlarmThreshold' | translate }}</span
            >
            <span
              id="ac-error1"
              class="error"
              *ngIf="updateThresholdsForm?.get('notification1')?.getError('pattern')"
              >{{ 'alarmThresholds.twoDecimalsAlarmThreshold' | translate }}</span
            >
          </div>
        </div>
        <div
          class="rs-form-item"
          [ngClass]="{
            error: updateThresholdsForm?.get('notification2').status !== 'VALID',
            'rs-form-success':
              !updateThresholdsForm?.getError('mustBeDifferent') &&
              !updateThresholdsForm?.getError('atLeastOne') &&
              updateThresholdsForm?.get('notification2').status === 'VALID'
          }"
        >
          <div class="rs-flex-row rs-flex-middle">
            <div class="rs-flex-columns small-11 medium-6">
              <input
                *ngIf="isRes"
                type="number"
                id="notification2"
                formControlName="notification2"
                aria-describedby="ac-helper2"
                data-cy="alarmThresholdNotification2"
              />
              <input
                *ngIf="!isRes"
                type="number"
                step="0.01"
                id="notification2"
                formControlName="notification2"
                aria-describedby="ac-helper2"
              />
              <label
                class="rs-form-label"
                for="notification2"
                aria-describedby="ac-error2"
                [ngClass]="{
                  error:
                    updateThresholdsForm?.getError('mustBeDifferent') ||
                    updateThresholdsForm?.getError('atLeastOne') ||
                    updateThresholdsForm?.get('notification2').status !== 'VALID'
                }"
                >{{ 'alarmThresholds.firstNotificationLabel' | translate }}</label
              >
            </div>
            <div *ngIf="isRes" class="rs-flex-columns small-1 medium-6">€</div>
            <div *ngIf="!isRes" class="rs-flex-columns small-1 medium-6">
              € {{ 'alarmThresholds.vat.excluded' | translate }}
            </div>
            <span
              id="ac-error2"
              class="error"
              *ngIf="
                updateThresholdsForm?.get('notification2')?.getError('min') ||
                updateThresholdsForm?.get('notification2')?.getError('max')
              "
              >{{ 'alarmThresholds.invalidIntervalAlarmThreshold' | translate }}</span
            >
            <span
              id="ac-error2"
              class="rs-form-helper"
              *ngIf="updateThresholdsForm?.getError('atLeastOne')"
              >{{ 'alarmThresholds.invalidIntervalAlarmThreshold' | translate }}</span
            >
            <span
              id="ac-error2"
              class="rs-form-helper"
              *ngIf="updateThresholdsForm?.getError('mustBeDifferent')"
              >{{ 'alarmThresholds.mustBeDifferent' | translate }}</span
            >
            <span
              id="ac-error2"
              class="error"
              *ngIf="updateThresholdsForm?.get('notification2')?.getError('pattern')"
              >{{ 'alarmThresholds.twoDecimalsAlarmThreshold' | translate }}</span
            >
          </div>
        </div>
        <div class="rs-flex-row rs-flex-middle-medium rs-flex-dir-col-small-only">
          <div class="rs-flex-column rs-order-m2">
            <button
              type="submit"
              class="rs-btn"
              [disabled]="!updateThresholdsForm?.valid || updateThresholdsForm?.pristine"
              data-cy="alarmThresholdSubmit"
            >
              {{ 'alarmThresholds.saveLabel' | translate }}
            </button>
          </div>
          <div class="rs-flex-column rs-flex-shrink rs-order-m1">
            <p class="text-center">
              <a href="javascript:void(0)" role="button" (click)="reset()">{{
                'alarmThresholds.cancelLabel' | translate
              }}</a>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
